var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notificator no-select"},[_c('transition-group',{attrs:{"name":"slide-fade"}},_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"notificator--item",class:{
        not_danger: item.color == 'danger',
        not_success: item.color == 'success'
      }},[_c('div',{staticClass:"notificator--close",on:{"click":function($event){return _vm.removeNotification(item)}}},[_c('f-awesome',{attrs:{"icon":"times"}})],1),_vm._v(" "+_vm._s(item.text)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }